import React, { useCallback, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import './app.scss'
import { Header } from '../../component/header'
import { Sidebar } from '../../component/sidebar'
import { Routers } from './Routers'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { isAuthorized, isLoading, appFetch } from '../../store/reducer/app'
import { Preloader } from '../../component/common'

export const App = () => {
  const isUserAuthorized = useAppSelector(isAuthorized)
  const isAppLoading = useAppSelector(isLoading)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const token = searchParams.get('t')

  const fetch = useCallback(() => {
    let SAMLToken = ''
    if (token) {
      token.split('').forEach((character) => {
        const s = character === ' ' ? '+' : character
        SAMLToken = SAMLToken + s
      })
      dispatch(appFetch(SAMLToken))
      navigate('/')
    }
  }, [token, dispatch, navigate])

  useEffect(() => {
    fetch()
  }, [fetch])

  const renderLogin = () => {
    if (isAppLoading) {
      return (
        <main className='f f-d-c f-jc-c f-ai-c'>
          <Preloader size='md' />
        </main>
      )
    } else {
      return (
        <main className='f f-d-c f-jc-c f-ai-c'>
          Login to
          <a
            href='https://console.jumpcloud.com/login'
            className='m-y-md'
          >
            <svg
              width='200px'
              xmlns='http://www.w3.org/2000/svg'
              viewBox='0 0 409 77'
            >
              <path
                fill='#14141E'
                d='M19.988 59.689V19.03H7.592v42.3c0 2.825-.913 4.74-3.739 4.74-.979 0-1.956-.092-2.918-.274L.389 76.463a28.5 28.5 0 004.01.363c11.397 0 15.589-6.654 15.589-17.137zm36.83 2.46h12.125V18.94H56.454v24.066c0 5.47-3.282 9.208-8.568 9.208-4.558 0-6.564-3.008-6.564-7.475v-25.8h-12.4v29.263c0 9.39 4.195 15.224 12.4 15.224 6.836 0 12.124-4.376 14.584-12.763h.912V62.15zm33.277-24.066c0-5.378 3.374-9.116 8.66-9.116 4.466 0 6.565 3.008 6.565 7.384V62.15h12.396V38.083c0-5.378 3.282-9.116 8.57-9.116 4.56 0 6.563 3.008 6.563 7.384V62.15h12.489V32.887c0-9.39-4.284-15.133-12.76-15.133-7.113 0-12.036 4.467-14.406 12.945h-1.002c-.548-8.114-4.284-12.945-11.942-12.945-6.837 0-12.033 4.375-14.495 12.763h-.913V18.939H77.697v43.21h12.399V38.084zm105.753 2.552c0-14.858-5.381-22.88-14.862-22.88-6.928 0-11.668 4.557-13.946 12.124h-.82v-10.94h-12.4v57.067h12.399v-25.16h.728c2.188 7.566 6.838 12.58 14.038 12.58 9.299 0 14.862-7.93 14.862-22.79zM174.97 52.486c-5.286 0-8.75-4.01-8.75-10.028v-3.373c0-6.198 3.372-10.118 8.842-10.118 5.924 0 8.569 3.738 8.569 11.668 0 7.932-2.645 11.851-8.66 11.851zm55.976-15.953l11.487-2.188c-1.55-10.484-7.019-16.59-19.874-16.59-13.764 0-22.15 8.66-22.15 23.336 0 14.768 8.568 22.335 22.243 22.335 12.306 0 18.415-6.29 19.873-16.318l-11.395-2.734c-.912 4.466-3.01 8.204-8.57 8.204-6.38 0-9.481-4.467-9.481-12.125 0-8.204 3.556-11.85 9.298-11.85 5.47 0 7.475 3.28 8.569 7.93zm31.09-32.909h-12.399V62.15h12.4V3.624zm29.172 59.802c13.765 0 22.151-8.66 22.151-22.882 0-14.404-8.66-22.79-22.151-22.79-13.765 0-22.335 8.386-22.335 22.79 0 14.221 8.296 22.882 22.335 22.882zm-.092-35.28c6.838 0 9.847 4.467 9.847 12.307 0 7.84-2.919 12.398-9.847 12.398-7.018 0-9.845-4.558-9.845-12.398s3.009-12.306 9.845-12.306zm56.613 34.004h12.125V18.94h-12.488v24.065c0 5.47-3.283 9.208-8.569 9.208-4.558 0-6.564-3.008-6.564-7.475V18.939h-12.4v29.263c0 9.39 4.195 15.224 12.4 15.224 6.836 0 12.124-4.376 14.584-12.763h.912V62.15zm48.412 0h12.397V3.624H396.14V29.88h-.822c-2.278-7.567-6.929-12.125-13.855-12.125-9.483 0-14.95 8.114-14.95 23.155 0 14.586 5.467 22.517 14.766 22.517 7.202 0 11.943-5.014 14.13-12.58h.731V62.15zm-8.753-9.664c-6.108 0-8.75-3.828-8.75-11.577 0-8.113 2.734-11.942 8.66-11.942 5.469 0 8.843 4.01 8.843 10.301v3.374c0 6.016-3.556 9.844-8.753 9.844zM20.474 6.858a6.684 6.684 0 11-13.369 0 6.684 6.684 0 0113.37 0z'
              />
            </svg>
          </a>
          or
          <a
            href='https://myapps.microsoft.com/'
            className='m-t-md m-b-md'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='150px'
              height='43.2px'
              viewBox='0 0 150 43.2'
            >
              <path
                fill='#0089D6'
                d='M25.8,40.9c7.2-1.3,13.1-2.3,13.2-2.3l0.1,0l-6.8-8c-3.7-4.4-6.8-8.1-6.8-8.1c0,0,7-19.3,7-19.4c0,0,4.8,8.2,11.5,19.9c6.3,11,11.5,20,11.6,20.1l0.1,0.2l-21.5,0l-21.5,0C12.8,43.2,25.8,40.9,25.8,40.9z M108.3,39c-3.3-0.2-5.2-2.1-5.7-5.6c-0.1-0.9-0.1-1-0.1-7l0-5.8h1.4h1.4l0,5.6c0,5.1,0,5.7,0.1,6c0.2,1.5,0.6,2.4,1.3,3.1c0.5,0.6,1.2,0.9,2,1.1c0.4,0.1,1.6,0.1,1.9,0c0.9-0.2,1.6-0.6,2.2-1.2c0.7-0.7,1.2-1.7,1.5-2.8l0.1-0.4l0-5.7l0-5.7h1.5h1.5v8.9v8.9h-1.5h-1.5v-1.4c0-1,0-1.4,0-1.4c0,0-0.1,0.1-0.2,0.3c-0.5,0.9-1.3,1.8-2.3,2.3C110.9,38.8,109.8,39.1,108.3,39L108.3,39z M141.5,38.9c-1.2-0.1-2.4-0.5-3.4-1.1c-2.1-1.3-3.3-3.4-3.7-6.4c-0.1-1-0.1-2.4,0-3.2c0.2-1.9,1-3.8,2.1-5.2c0.3-0.3,0.9-1,1.3-1.3c0.9-0.7,2-1.3,3.2-1.5c0.7-0.1,1.9-0.2,2.6-0.2c1.8,0.2,3.5,1,4.6,2.4c1.1,1.4,1.8,3.3,1.9,5.6c0,0.4,0,1,0,1.4l0,0.8l-6.3,0l-6.3,0v0.3c0,0.9,0.2,1.8,0.6,2.7c0.3,0.7,0.8,1.5,1.3,1.9c0.9,0.8,2,1.2,3.2,1.4c0.4,0,1.6,0,2.1-0.1c1.5-0.2,2.8-0.8,4-1.6c0.1-0.1,0.3-0.2,0.3-0.2c0,0,0,0.2,0,1.3l0,1.3l-0.3,0.2c-1.3,0.8-2.7,1.3-4.2,1.5C143.7,39,142.1,39,141.5,38.9L141.5,38.9z M147,27.6c0-1.4-0.6-3-1.5-3.9c-0.6-0.6-1.4-0.9-2.2-1.1c-0.4-0.1-1.3,0-1.7,0c-0.9,0.2-1.7,0.6-2.4,1.3c-0.7,0.7-1.2,1.5-1.6,2.5c-0.1,0.3-0.3,0.9-0.3,1.2l0,0.2h4.9h4.9V27.6z M61,38.5c0,0,2.2-5.7,4.8-12.6l4.8-12.5l1.5,0l1.5,0l0.1,0.3c0.4,1,9.6,24.8,9.6,24.8c0,0-0.7,0-1.6,0l-1.6,0L78.7,35l-1.3-3.5l-5.3,0l-5.3,0l0,0.1c0,0.1-0.6,1.6-1.3,3.5l-1.2,3.4l-1.6,0C61.3,38.5,61,38.5,61,38.5L61,38.5z M76.4,28.8c0,0-0.9-2.4-2-5.4c-2-5.5-2.1-5.8-2.3-6.7c-0.1-0.4-0.1-0.4-0.2,0c0,0.3-0.2,0.9-0.3,1.2c-0.1,0.2-1,2.7-2,5.6c-1.1,2.9-1.9,5.3-1.9,5.3c0,0,2,0,4.3,0C74.5,28.8,76.4,28.8,76.4,28.8z M84.3,38.1v-0.5l5.3-7.3l5.3-7.3l-4.8,0l-4.8,0l0-1.2l0-1.2h6.9h6.9V21v0.4l-5.3,7.3c-2.9,4-5.3,7.3-5.3,7.3c0,0,2.4,0,5.2,0H99v1.2v1.2h-7.4h-7.4V38.1z M123.2,38.5c0,0,0-4.1,0-9v-9h1.4h1.4v1.8c0,1,0,1.8,0,1.8s0.1-0.2,0.2-0.4c0.3-0.9,0.9-1.8,1.6-2.5c0.7-0.6,1.4-1,2.3-1.1c0.2,0,0.5,0,1,0c0.6,0,0.9,0.1,1.3,0.2l0.1,0V22v1.5l-0.3-0.2c-0.6-0.3-1.2-0.4-1.9-0.4c-0.5,0-0.8,0.1-1.1,0.2c-0.8,0.3-1.4,0.8-1.8,1.5c-0.6,1-1.1,2.3-1.2,3.5c0,0.2,0,1.9,0,5.4l0,5.1h-1.4C123.8,38.5,123.2,38.5,123.2,38.5z M0,38.5c0,0,3.2-5.5,7.1-12.3l7.1-12.3l8.3-6.9C27,3.1,30.7,0,30.7,0c0,0,0,0.1-0.1,0.3c-0.1,0.2-4.1,8.8-9,19.2l-8.8,18.9l-6.4,0C2.9,38.5,0,38.5,0,38.5z'
              />
            </svg>
          </a>
          for use application.
        </main>
      )
    }
  }

  const RenderApp = () => (
    <main className='f f-d-r f-jc-c'>
      <Sidebar />
      <section
        className='f f-d-c f-ai-s p-x-xl p-y-lg'
        style={{
          overflowY: 'auto',
          maxHeight: 'calc(100vh - 75px)',
        }}
      >
        <Routers />
      </section>
    </main>
  )

  return (
    <>
      <Header />
      {isUserAuthorized ? RenderApp() : renderLogin()}
    </>
  )
}
